<template>
  <div class="info-box">
    <div class="info-icon"><i :class="classes"></i></div>
    <div class="info-content">
      <span>{{ title }}</span>
      <span class="info-total">{{ total }}</span>
    </div>
  </div>
</template>

<script>
  import main from './InfoBox.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './InfoBox.scss';
</style>



// WEBPACK FOOTER //
// InfoBox.vue?47460c44